import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { Artifacts } from 'ui';

import { fetchArtifacts } from 'services';
import { artifactsParser } from 'shared/parsers';

const page = 1;

export const IssuerDashboardResearchWidget = ({ sector, industry, limit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isPending, setIsPending] = useState(!!sector);
  const [artifacts, setArtifacts] = useState([]);

  const getArtifacts = async () => {
    try {
      setIsPending(true);
      const { data } = await fetchArtifacts({
        page,
        limit,
        type: 'INDUSTRY_RESEARCH',
        industryCode: sector,
      });

      setArtifacts(artifactsParser(data));
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => {
    getArtifacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleItemClick = (itemId) => {
    navigate({ pathname: `/announcements/${itemId}`, prevPath: location.pathname });
  };

  return (
    <>
      <Artifacts
        data={artifacts}
        isPending={isPending}
        onItemClick={handleItemClick}
        currentPage={page}
      />
      <Box py={2}>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Button
              variant="outlined"
              onClick={() =>
                navigate(
                  `/credit-rating-coverage/industry?code=${sector}&industryCode=${industry}&tab=research`,
                )
              }
            >
              {t('View all')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

IssuerDashboardResearchWidget.defaultProps = {
  industry: null,
  sector: null,
};

IssuerDashboardResearchWidget.propTypes = {
  limit: PropTypes.number.isRequired,
  industry: PropTypes.string,
  sector: PropTypes.string,
};
